<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div v-if="unauthorized">
                <h4>{{ $t('unauthorizedMessage')}}</h4>
            </div>
            <div v-else>
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button"
                            class="btn btn-primary"
                            @click="backToModels">
                        <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                    </button>
                </div>
                <div class="form-group" v-if="loaded">
                    <org-model :organizationalModel="model"
                               @saved="modelSaved"
                               @orgModelActivated="activateDeactivateToggle"
                               @orgModelDeactivated="activateDeactivateToggle">

                    </org-model>
                </div>

                <div class="form-group">
                    <item-list ref="itemsGrid"
                               :organizationalModel="model">
                    </item-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OrgModel from './Model';
    import ItemList from './ItemList';
    import { OrganizationalModel } from '../../models/models';
    import orgModelService from '../../services/orgModel.service';

    export default {
        props: {
            id: {
                type: Number,
                required: true,
            },
            details: {
                type: Boolean,
                default: false
            },
        },
        components: {
            OrgModel,
            ItemList
        },
        data() {
            return {
                componentTitle: this.$t('scheduler.agenda'),
                loading: false,
                unauthorized: false,
                model: null,
                loaded: false,
            }
        },
        methods: {
            load() {
                this.loading = true;

                orgModelService
                    .getById(this.id)
                    .then(response => {
                        this.loading = false;
                        if (response.data) {
                            this.model = new OrganizationalModel(response.data);
                            this.loaded = true;
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        let statusCode = this.$helpers.errorStatusCode(error);
                        if (statusCode === 403) {
                            this.accessDenied();
                            return;
                        }
                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            accessDenied() {
                this.unauthorized = true;
            },
            backToModels() {
                this.$router.push('/organizationalModels');
            },
            modelSaved(model) {
                if (!this.model) {
                    this.model = new OrganizationalModel();
                }

                this.updateModel(model);
            },
            updateModel(m) {
                this.model.id = m.id;
                this.model.name = m.name;
                this.model.nameEn = m.nameEn;
                this.model.description = m.description;
                this.model.deactivated = m.deactivated;
                this.model.createdBy = m.createdBy;
                this.model.createdAt = m.createdAt;
                this.model.eventFormIds = m.eventFormIds;
                this.model.eventActivityIds = m.eventActivityIds;
            },
            activateDeactivateToggle() {
               
            }
        },
        beforeMount() {
            this.load()
        },
        mounted() {
        },
        computed: {

        }
    }
</script>

<style scoped>
</style>
